import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton, CircularProgress } from "material-ui"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import Table from "../../../components/common/Table"
import strings from "../../../localization/strings"
import Clear from "../../../components/misc/Clear"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import { ISpecialtyInfo, ISpecialty } from "../../../models"
import * as api from "../../../api"

interface IProps {
	handleClose(): void
	handleSave(Specialties: ISpecialtyInfo[]): void
}
interface IState {
	SpecialtiesList: ISpecialty[]
	selectedSpecialties: ISpecialtyInfo[]
	search: string
	loading: boolean
	total: number
	offset: number
	limit: number
}
const styles = {
	nameCol: {
		paddingLeft: 5,
		paddingRight: 5,
		cursor: "pointer"
	},
	otherCol: {
		paddingLeft: 5,
		paddingRight: 5,
		width: 75
	}
}

export default class ChooseSpecialtyDialogForChip extends React.Component<IProps, IState> {
	private Specialties: ISpecialty[]
	constructor(props) {
		super(props)
		this.Specialties = []
		this.state = {
			SpecialtiesList: [],
			selectedSpecialties: [],
			search: "",
			loading: false,
			total: 0,
			offset: 0,
			limit: 8,
		}
		autobind(this)
	}

	componentDidMount() {
		this.getSpecialtiesList()
	}

	getSpecialtiesList() {
		this.setState({ loading: true }, () => {
			api.getAccountHRISSpecialties(AccountStore.getCurrentAccount().Id)
			.then(res => {
				this.Specialties = res.data.filter(specialty => specialty.Active) as ISpecialty[]
				this.setState({
					SpecialtiesList: this.Specialties.slice(0,this.state.limit),
					total: this.Specialties.length,
					loading: false
				})
			})
			.catch(_err => {
				this.Specialties = []
				this.setState({
					SpecialtiesList: [],
					total: this.Specialties.length,
					loading: false
				}, () => AppStateStore.setProgressSnackbarContent(strings.something_went_wrong))
			})
		})
	}
	
	// Updating the List for Client-Side Pagination & Searching
	updateSpecialtyList() {
		const filteredList = this.Specialties.filter(item => !this.state.search || item.Name.toLowerCase().includes(this.state.search.toLowerCase())).filter((_v, index) => index >= this.state.offset && index < this.state.offset + this.state.limit)
		if (this.state.search !== "") this.setState({ SpecialtiesList: filteredList, total: filteredList.length })
		else this.setState({ SpecialtiesList: filteredList, total: this.Specialties.length })
	}
	
	handleSelectSpecialties(selectedSpecialties) {
		selectedSpecialties = selectedSpecialties.slice().map(specialty => (
			{
				Id: specialty.Id,
				Name: specialty.Name,
			}
		))
		this.setState({ selectedSpecialties })
	}

	SpecialtiesTable = () => (
		!this.state.SpecialtiesList.length ?
			<h2 style={{ textAlign: "center", marginTop: 25 }}>
			{strings.No_Specialty_Found}
			</h2> :
		<Table
			items={this.state.SpecialtiesList}
			handleSelect={this.handleSelectSpecialties}
			total={this.state.total}
			offset={this.state.offset}
			limit={this.state.limit}
			limitOptions={[8, 20, 50]}
			onPageClick={offset => this.setState({ offset }, () => this.updateSpecialtyList())}
			onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.updateSpecialtyList())}
		>
			<TableHeader>
				<TableRow>
					<TableHeaderColumn style={styles.nameCol}>{strings.Name}</TableHeaderColumn>
				</TableRow>
			</TableHeader>
			<TableBody showRowHover deselectOnClickaway={false}>
				{this.state.SpecialtiesList.map((item, index) =>
					<TableRow key={index} selected={this.state.selectedSpecialties.find(specialty => specialty.Id === item.Id) ? true : false}>
						<TableRowColumn style={styles.nameCol} title={item.Name}>{item.Name}</TableRowColumn>
					</TableRow>
				)}
			</TableBody>
		</Table>
	)

	render() {
		return (
			<Dialog
				modal
				open
				title={strings.Choose_Specialties}
				actions={[
					<FlatButton
						label={strings.Cancel}
						secondary
						onClick={this.props.handleClose}
					/>,
					<FlatButton
						label={strings.OK}
						primary
						keyboardFocused
						disabled={this.state.selectedSpecialties.length > 0 ? false : true}
						onClick={() => {
							this.props.handleSave(this.state.selectedSpecialties)
						}}
					/>
				]}
				onRequestClose={this.props.handleClose}
			>
				<div style={{ padding: 20, paddingLeft: 35 }}>
					<i style={{ fontSize: 25 }} className="fa fa-search" />
					<TextField
						hintText={strings.search}
						style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
						value={this.state.search}
						onChange={e => this.setState({ search: e.target.value, offset: 0 }, () => this.updateSpecialtyList())}
					/>
					<Clear />
				</div>
				<div style={{ textAlign: "center", height: "auto", minHeight: 520 }}>
					{this.state.loading ?
						<CircularProgress /> :
						<div>{this.SpecialtiesTable()}</div>
					}
				</div>
			</Dialog>
		)
	}
}